<template>
  <div class="container">
    <div class="searchbox">
      <div class="title"><b> 实验室查询</b></div>
      <div class="flex" >
        <iframe style="width: 100%;min-height: 836px;" src="https://3coa.cccap.org.cn/do/manage/foreign_interface/list_lab/?lab_name=&pageSize=20&p=1" frameborder="0"></iframe>

      </div>
    </div>
  </div>

</template>

<script>
import SliderVerify from './SliderVerify.vue';
export default {
  name: "certification",
  components: {
    SliderVerify
  },
  data(){
    return {
      years:[],
      show:false,
      query:{
        uuid:''
      },
      codeUrl:'',
      uuid:'',
      style:1
    }
  },
  mounted() {
    if(this.$store.state.stations.id != 1004){
      this.getCode()
    }
    this.style = process.env.VUE_APP_BASE_STYLE
  },
  methods:{
    ok(){
      this.$emit("queryClick",this.query)
      this.show = false;
    },
    close(val){
      this.show = val;
    },
    sumitQuery(){
      // 验证至少填写一个主要查询条件
      if(!this.query.cert_code && !this.query.factoryName && !this.query.facCoding) {
        this.$message.error('请至少填写证书编号、生产企业或工厂代码中的一个');
        return;
      }
      this.show = true;
    },
    async getCode(){
      let res = await this.$api.getCaptcha({});
      console.log(res)
      this.codeUrl = "data:image/gif;base64," + res.data.data.img;
      this.query.uuid = res.data.data.uuid
    }
  }
}
</script>

<style scoped>
.searchbox{
  position: relative;
}

</style>
